// client\src\pages\visitor\parceirosPage.jsx

import React, { useEffect, useState, } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../api/axios';
import styles from '../../App.module.css';
import GraficoParceiros from '../../components/Graficos/GraficoParceiro';
import { FaLink, FaWhatsapp } from 'react-icons/fa';


export default function ParceirosPage() {

    console.log('Renderizando ParceirosPage...');
    const { usuarioParceiro } = useParams(); // Obtém o clienteId da URL
    console.log('usuarioParceiro:', usuarioParceiro); // Verifica se o clienteId está sendo obtido corretamente
    const [parceiroId, setParceiroId] = useState(null);
    const [parceiroNaoEncontrado, setParceiroNaoEncontrado] = useState(false);



    const [dadosParceiro, setDadosParceiro] = useState(null);
    const [vendasParceiro, setVendasParceiro] = useState([]);

    useEffect(() => {
        async function fetchParceiroPorUsuario() {
            try {
                const response = await api.get(`/parceiroPorUsuario/${usuarioParceiro}`);
                if (response.data && response.data.id) {
                    setParceiroId(response.data.id);
                    console.log('ID do parceiro:', response.data.id); // Verifica se o ID do parceiro está sendo obtido corretamente
                    fetchDadosParceiro(response.data.id);
                    fetchVendasParceiro(response.data.id);
                } else {
                    setParceiroNaoEncontrado(true);
                }
            } catch (error) {
                console.error('Erro ao buscar parceiro pelo usuarioParceiro:', error);
                setParceiroNaoEncontrado(true); // Se deu erro (tipo 404), considera como não encontrado
            }
        }


        async function fetchDadosParceiro(id) {
            console.log('Buscando dados do parceiro com ID:', id); // Verifica se o ID do parceiro está sendo passado corretamente
            try {
                const response = await api.get(`/clientesPorParceiro/${id}`);
                console.log('Dados do parceiro:', response.data); // Verifica se os dados do parceiro estão sendo obtidos corretamente
                setDadosParceiro(response.data);
            } catch (error) {
                console.error('Erro ao buscar dados do parceiro:', error);
            }
        }

        async function fetchVendasParceiro(id) {
            try {
                const response = await api.get(`/historicoVendasPorParceiro/${id}`);
                console.log('Vendas do parceiro:', response.data);
                setVendasParceiro(response.data);
            } catch (error) {
                console.error('Erro ao buscar vendas do parceiro:', error);
            }
        }

        fetchParceiroPorUsuario();
    }, [usuarioParceiro]);




    const comissaoTotal = vendasParceiro.reduce((total, item) => total + item.valor * 0.15, 0).toFixed(2);

    if (parceiroNaoEncontrado) {
        return (
            <div className={styles.app} style={{ textAlign: 'center', padding: '40px' }}>
                <img
                    src="\memoji\Ainglobal.gif"
                    alt="Penguin GIF"
                    style={{
                        maxWidth: '200px',
                        height: 'auto',
                        display: 'block',
                        margin: '20px auto',
                        borderRadius: "20px"
                    }}
                />
                <h1 style={{ marginBottom: '20px' }}>Parceiro não encontrado!</h1>
                <h2>Certifique de que você acessou o link correto.</h2>
                <button
                    style={{
                        backgroundColor: "red",
                        color: "white",
                        padding: "15px 30px",
                        fontSize: "18px",
                        borderRadius: "10px",
                        cursor: "pointer",
                        marginTop: "20px",
                        border: "4px solid var(--corPrimaria)",
                    }}
                    onClick={() => {
                        window.open('https://wa.me/5561998819381?text=Ol%C3%A1%2C+gostaria+de+ajuda+para+me+tornar+parceiro!', '_blank');
                    }}
                >
                    Quero me tornar um parceiro
                </button>
                <button
                    style={{
                        backgroundColor: "var(--corPrimaria)",
                        color: "white",
                        padding: "15px 30px",
                        fontSize: "18px",
                        borderRadius: "10px",
                        cursor: "pointer",
                        marginTop: "20px"
                    }}
                    onClick={() => {
                        window.open('https://wa.me/5561998819381?text=Ol%C3%A1%2C+gostaria+de+ajuda+para+me+tornar+parceiro!', '_blank');
                    }}
                >
                    Entrar em contato
                </button>
            </div>
        );
    }

    return (
        <div className={styles.app}>
            <p className={styles.titulo} style={{ padding: "10px" }}>Bem-Vindo(a) {dadosParceiro?.nomeParceiro || 'Carregando...'}</p>


            <div className={`${styles.corTitulo} ${styles.blue}`}>
                <p className={styles.titulo}>Compartilhe e ganhe:</p>
            </div>

            <div className={styles.cadastroClienteContainer}>
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <h3>Total de acessos ao site com seu link:</h3>
                    <p style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#4caf50' }}>
                        {dadosParceiro?.contaSite ?? '-'}
                    </p>
                </div>


                <h3 style={{ marginTop: '20px' }}>Seus links de comissão:</h3>

                <button
                    style={{
                        backgroundColor: "var(--corPrimaria)",
                        color: "white",
                        padding: "10px",
                        borderRadius: "10px",
                        textAlign: "center",
                        cursor: "pointer",
                        width: "90%",
                        marginBottom: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px'
                    }}
                    onClick={() => {
                        const linkSite = `https://agilizavisto.com/?parceiro=${dadosParceiro?.usuarioParceiro}`;
                        navigator.clipboard.writeText(linkSite);
                        alert('🔗 Link para o site copiado!');
                    }}
                >
                    <FaLink size={24} />
                    <h2 style={{ margin: 0 }}>Copiar Link para o Site</h2>
                </button>



                <button
                    style={{
                        backgroundColor: "var(--corPrimaria)",
                        color: "white",
                        padding: "10px",
                        borderRadius: "10px",
                        textAlign: "center",
                        cursor: "pointer",
                        width: "90%",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px'
                    }}
                    onClick={() => {
                        const linkWhats = `https://api.whatsapp.com/send?phone=5561998819381&text=Olá,+gostaria+de+agilizar+o+meu+visto+americano.+Você+pode+me+ajudar%3F+Cheguei+até+vocês+através+do+parceiro+${dadosParceiro?.usuarioParceiro}.`;
                        navigator.clipboard.writeText(linkWhats);
                        alert('📱 Link para WhatsApp copiado!');
                    }}
                >
                    <FaWhatsapp size={24} />
                    <h2 style={{ margin: 0 }}>Copiar Link para WhatsApp</h2>

                </button>
            </div>

            <div className={`${styles.corTitulo} ${styles.green}`}>
                <p className={styles.titulo}>Resumo:</p>
            </div>

            <div className={styles.cadastroClienteContainer}>
                <div style={{ padding: '20px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around' }}>
                    <div className={styles.vendasParceiro}>
                        <h3 style={{ marginTop: '20px' }}>Clientes indicados:</h3>
                        <p style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{dadosParceiro?.total_clientes ?? '-'}</p>
                    </div>
                    <div className={styles.vendasParceiro}>
                        <h3 style={{ marginTop: '20px' }}>Vendas Registradas:</h3>
                        <p style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{vendasParceiro.length}</p>
                    </div>
                </div>

                {/* <div style={{ padding: '20px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', marginTop: '-40px' }}>
                    <div className={styles.vendasParceiro} style={{ backgroundColor: "#8aff8a" }}>
                        <h3 style={{ marginTop: '20px' }}>Taxa de conversão:</h3>
                        <p style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
                            {dadosParceiro?.contaSite && dadosParceiro?.total_clientes
                                ? ((dadosParceiro.total_clientes / dadosParceiro.contaSite) * 100).toFixed(1) + '%'
                                : '-'}
                        </p>
                    </div>



                    <div className={styles.vendasParceiro} style={{ backgroundColor: "rgb(255, 187, 0)" }}>
                        <h3 style={{ marginTop: '20px' }}>Comissão total:</h3>
                        <p style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>R$ {comissaoTotal}</p>
                    </div>
                </div> */}
            </div>

            <div className={`${styles.corTitulo} ${styles.yellow}`}>
                <p className={styles.titulo}>Hitórico de Comissões</p>
            </div>

            <div className={styles.cadastroClienteContainer}>
                <div
                    className={styles.cadastroItems06}
                    style={{
                        borderRadius: "20px",
                        backgroundColor: "white",
                        overflow: "visible",
                        maxWidth: "600px",
                        paddingTop: "40px",
                    }}
                >
                    <GraficoParceiros rawData={vendasParceiro} intervalo={60} />
                </div>
            </div>

            <div className={styles.rodape}></div>
        </div>
    );
}
